import { ModalIOF } from '@old/ui/modal/modal';
import { configButtonStylesContained } from '@old/styles/generic-styles';
import { Autocomplete, TextField, Chip, Typography, Button, CircularProgress } from '@mui/material';
import { useService } from '@old/hooks/use-service';
import { SendSilobagWarrantsService } from '@old/services/domain/base/administrator/warrants/send-sb-warrants';
import PampaImage from '@old/assets/images/pampa-negocios.png';
import { useGlobalStore } from '@old/global-store/use-store';
import CheckIcon from '@old/assets/svg/check-with-border.svg';

type WarrantModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  companyId: string;
  data: {
    id: string;
    name: string;
    fullPermissions: boolean;
  }[];
};

export const WarrantApplicationModal = ({ open, setOpen, data, companyId }: WarrantModalProps) => {
  const { trigger, isSuccess, isLoading } = useService(SendSilobagWarrantsService);
  const { email } = useGlobalStore();
  const dataIdsFullPermissions = data.filter((item) => item.fullPermissions).map((item) => item.id);
  const dataWithoutFullPermissions = data.filter((item) => !item.fullPermissions);

  const handleSendWarrant = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;

    const body = {
      companyId: companyId,
      assets: data.map((item) => ({
        id: item.id,
        name: item.name,
        silobagLink: `${baseUrl}/silobag/${item.id}`,
      })),
      emails: email,
      assetType: 'silobag',
    };
    trigger(body);
  };

  return (
    <ModalIOF open={open} ModalIsOpen={setOpen}>
      <ModalIOF.HeaderCenter>
        <ModalIOF.Title>
          {!isSuccess ? (
            'Solicitá tu warrant'
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <img style={{ width: '200px' }} src={PampaImage} alt="" />
              <img style={{ width: '30px', marginRight: '10px', marginTop: 20 }} src={CheckIcon} alt="" />
            </div>
          )}
        </ModalIOF.Title>
      </ModalIOF.HeaderCenter>
      {!isSuccess ? (
        <ModalIOF.Body>
          <Autocomplete
            size="small"
            multiple
            limitTags={10}
            id="multiple-limit-tags"
            options={[]}
            getOptionLabel={(option) => option}
            defaultValue={dataIdsFullPermissions ?? []}
            onChange={(_, value) => {
              if (value.length === 0) {
                setOpen(false);
              }
            }}
            renderInput={(params) => <TextField {...params} label="Silobolsas" placeholder="Silobolsas" />}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option}
                  {...getTagProps({ index })}
                  sx={{
                    minWidth: '100px',
                    margin: '2px',
                  }}
                />
              ))
            }
            sx={{ width: '100%' }}
            open={false}
          />
          <Typography variant="body2" sx={{ marginTop: '10px' }}>
            Se ha seleccionado {dataIdsFullPermissions.length} Silobolsas
          </Typography>
          {dataWithoutFullPermissions.length > 0 && (
            <>
              <Typography variant="body2" sx={{ marginTop: '10px' }}>
                La solicitud no se pudo realizar para los siguientes silobolsas
              </Typography>
              <Typography variant="body2" sx={{ fontSize: '12px', color: '#b6b6b4', marginBottom: '10px' }}>
                *Se necesita permisos completos para solicitar un Warrant
              </Typography>
              {dataWithoutFullPermissions.map((item) => (
                <Typography variant="body2" sx={{ fontSize: '14px', color: 'red', marginBottom: '5px' }}>
                  {item.id} - {item.name}
                </Typography>
              ))}
            </>
          )}
          <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
            <ModalIOF.Helper>
              <Button onClick={() => setOpen(false)}>Cancelar</Button>
              <Button
                variant="contained"
                size="medium"
                sx={configButtonStylesContained}
                onClick={handleSendWarrant}
              >
                {isLoading ? (
                  <CircularProgress size={20} sx={{ color: '#fff' }} />
                ) : (
                  <span style={{ color: '#fff' }}>Confirmar</span>
                )}
              </Button>
            </ModalIOF.Helper>
          </div>
        </ModalIOF.Body>
      ) : (
        <ModalIOF.Body>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Typography variant="h5" sx={{ marginTop: '10px' }}>
              Solicitud Exitosa
            </Typography>
            <Typography
              variant="body2"
              sx={{ marginTop: '10px', textAlign: 'center', fontSize: '14px', maxWidth: '500px' }}
            >
              Estamos procesando la solicitud, la warrantera Pampa Negocios y Garantia se comunicará con usted
              en breve.
            </Typography>
            <Button sx={{ marginTop: 3 }} onClick={() => setOpen(false)}>
              {' '}
              Cerrar
            </Button>
          </div>
        </ModalIOF.Body>
      )}
    </ModalIOF>
  );
};
